import React,{ Component } from 'react';
import Vas from  '../Vas';
import { Icon } from 'component-lib';
import '../css/SideNavigation.css';
import $ from 'jquery';
import PanelsLinks from './PanelsLinks';
import ClosePopUps from 'utils-lib/build/elements/ClosePopUps';

class SideNavigation extends Component
{
    componentDidMount()
    {
      let me = this;
      let body = $("body");
      //body.css("background-color", "white");
      body.bind("click",function(){
          var burgerMenuClick = localStorage.getItem("BurgerMenu","BurgerMenu");

          if(burgerMenuClick !== "BurgerMenu")
              {document.getElementById("mySidenav").style.width = "0";}
          else
              {localStorage.setItem("BurgerMenu","");}

          me.setState({});
      });

      $(document).keyup(function(e){

          if(e.which === 27){
              if($("#mySidenav").length>0)
                  {document.getElementById("mySidenav").style.width = "0";}

          }
      });

      let burgerMenu = $("#Menu");
      //body.css("background-color", "white");        
      burgerMenu.bind("click",function(){

          if(document.getElementById("mySidenav").style.width === "" || document.getElementById("mySidenav").style.width === "0px")
              {
                  document.getElementById("mySidenav").style.width = "auto";
                  localStorage.setItem("BurgerMenu","BurgerMenu");
              }

          me.setState({});
      });
    }
    
    changePage(n){
        ClosePopUps.close();  
        window.location.pathname = n[1].substr(1,n[1].length);
    }

    render(){
        
        let arr = PanelsLinks.SideNav('blbu');
        let AllPanels = [];
        arr.forEach(e => {
            if (e !== undefined){
                if (e.length !== 0){
                    AllPanels.push(e);
                }
            }
        });
        
        let links = JSON.parse(localStorage.getItem('links'));
        let shownLinks = [];
        if (links !== null){
            for (let i = 0; i< links.length; i++){
                let panel = links[i][0];
                for (let j = 0; j< AllPanels.length; j++){
                    if (AllPanels[j][3] === panel){
                        shownLinks.push(AllPanels[j]);
                        break;
                    }
                }
            }
        }
        let i = 0;
        return (<div 
          id="mySidenav" 
          className="SideNav">
          <table>
            <tbody>
              <tr key={i}>
                <td><Icon 
                  Name={"Home"} 
                  Size={36} 
                  Color={"white"} 
                  Align={"left"} 
                  OnClick={()=>{Vas.GetView("Home",[],true);}} 
                />
                </td>
                <td 
                  className={"linkMenue"} 
                  onClick={()=>{ Vas.GetView("Home",null,true); }}>{Vas.Resources.Menus["Home"]}</td>
              </tr>
              {shownLinks.map(n=>{
                        i++;
                        return (
                          <tr key={i}>
                            <td><Icon 
                              Name={n[0]} 
                              Size={36} 
                              Color={"white"} 
                              Align={"left"} 
                              OnClick={()=>{this.changePage(n);}} />
                            </td>
                            <td 
                              className={"linkMenue"} 
                              onClick={()=>{ this.changePage(n); }}>{n[2]}</td>
                          </tr>
                        );
                    })}
              <tr onClick={()=>{Vas.Signout(); }}>
                <td><Icon 
                  Name={"SignOut"} 
                  Size={36} 
                  Color={"white"} 
                  Align={"left"} />
                </td>
                <td>{Vas.Resources.Menus["SignOut"]}
                </td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default SideNavigation;
